import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { InfoSvgIconComponent } from '@components/svg-icons/info-svg-icon/info-svg-icon.component';

@Component({
  selector: 'ln-about-us-info-card',
  imports: [TranslocoPipe, InfoSvgIconComponent],
  templateUrl: './about-us-info-card.component.html',
  styleUrl: './about-us-info-card.component.css',
})
export class AboutUsInfoCardComponent {}
